<div
  class="munily-toggle-panel"
  [class.munily-toggle-panel--borderless]="isBorderless"
>
  <div class="munily-toggle-panel__row">
    <div class="munily-toggle-panel__text">
      <span class="munily-toggle-panel__state-label">{{ displayLabel }}</span>
      <p *ngIf="hasSubtitle" class="munily-toggle-panel__subtitle">
        {{ subtitle }}
      </p>
    </div>
    <div class="munily-toggle-panel__control">
      <common-toggle
        [checked]="checked"
        [disabled]="disabled"
        (change)="onToggleChange($event)"
      ></common-toggle>
    </div>
  </div>

  <div
    *ngIf="shouldShowFooter && footerTemplate"
    class="munily-toggle-panel__footer"
    (click)="$event.stopPropagation()"
  >
    <ng-container
      [ngTemplateOutlet]="footerTemplate"
      [ngTemplateOutletContext]="{ $implicit: footerContext }"
    ></ng-container>
  </div>
</div>
